<script setup>
import {ref} from "vue";
import aeonisLogo from '@/assets/images/aeonis_logo_white.svg';
import {useLoadingStore} from "@/stores/loading.js";
import {useUserStore} from "@/stores/user.js";

const userStore = useUserStore();
const loadingStore = useLoadingStore();

const expanded = ref(!!parseInt(localStorage.getItem('nav_expanded')));

const toggleExpanded = () => {
  expanded.value = !expanded.value;
  localStorage.setItem('nav_expanded', expanded.value ? 1 : 0);
}

const routes = [
  {label: 'Dashboard', name: 'dashboard', icon: 'gauge-high'},
  {label: 'Imagesets', name: 'imagesets.index', icon: 'images'},
  {label: 'Account', name: 'account', icon: 'user-gear'},
];

const logout = () => loadingStore.push(userStore.logout());
</script>

<template>
  <nav class="bg-gray-700 flex-none text-center text-xl text-neutral-100">
    <div class="h-[100vh] sticky top-0 flex flex-col justify-between">
      <header class="p-4 flex">
        <img :src="aeonisLogo" class="w-[23px]" alt="Aeonis logo" />
        <div class="flex-grow" v-if="expanded">
          <h1 class="font-bold pl-2">Aeonis</h1>
        </div>
      </header>

      <ul class="block mb-[10rem]" :class="{'text-left': expanded}">
        <li v-for="route in routes" :key="route.label">
          <router-link :to="{ name: route.name }" class="hover:bg-gray-900 block p-4"
                       active-class="bg-neutral-300 hover:bg-neutral-300 text-neutral-700">
            <font-awesome-icon class="text-xl" :icon="['fas', route.icon]"/>
            <span v-if="expanded" class="pl-2 text-base align-[1px]">{{ route.label }}</span>
          </router-link>
        </li>
        <li>
          <a class="p-4 cursor-pointer hover:bg-gray-900 block" @click="logout">
            <font-awesome-icon class="text-xl" :icon="['fas', 'arrow-right-to-bracket']" rotation="180"/>
            <span v-if="expanded" class="pl-2 text-base align-[1px]">Logout</span>
          </a>
        </li>
      </ul>

      <div class="p-4 hover:cursor-pointer hover:bg-gray-900" @click="toggleExpanded">
        <font-awesome-icon :icon="['fas', expanded ? 'angles-left' : 'angles-right']"/>
      </div>
    </div>
  </nav>
</template>
